// English, the source language: every other language is typed against it (D70).
import common from "./common";
import auth from "./auth";
import shell from "./shell";
import dashboard from "./dashboard";
import tasks from "./tasks";
import costs from "./costs";
import workflows from "./workflows";
import catalog from "./catalog";
import skills from "./skills";
import workloads from "./workloads";
import conversation from "./conversation";
import account from "./account";
import devices from "./devices";
import secrets from "./secrets";
import users from "./users";
import ratings from "./ratings";
import vpn from "./vpn";
import network from "./network";
import chat from "./chat";
import limits from "./limits";

export const en = { common, auth, shell, dashboard, tasks, costs, workflows, catalog, skills, workloads, conversation, account, devices, secrets, users, ratings, vpn, network, chat, limits };

export type Messages = typeof en;
